import React, { PropTypes } from 'react';
import ReactDOM from 'react-dom';

import Select from 'react-select';
import {connect} from 'react-redux';
import {bindActionCreators} from 'redux';
import {setComponentState,setSidebarState} from '../../actions/Builder.js';
import SidebarSettingAccordion from './SidebarSettingAccordion.js';
import SidebarElementSetting from './SidebarElementSetting.js';
import SidebarElementSpacing from './SidebarElementSpacing.js';
import SidebarElementWrapper from './SidebarElementWrapper.js';
import SidebarElementHeader from './SidebarElementHeader.js';
import Slider, { Range } from 'rc-slider';
import AlignPicker from './AlignPicker.js';
import FontPicker from "./FontPicker";

class List extends React.Component {
    constructor(props) {
        super(props);

        this.el = this.el.bind(this);
        this.handleBackClick = this.handleBackClick.bind(this);
        this.renderList = this.renderList.bind(this);
        this.renderFields = this.renderFields.bind(this);
        this.handleInputChange = this.handleInputChange.bind(this);
        this.handleAlignChange = this.handleAlignChange.bind(this);
        this.handleChange = this.handleChange.bind(this);

    }

    handleChange(id,s) {
        let changes = {};
        changes[id] = s;
        this.props.setComponentState(this.el().id,changes);
    }

    handleAlignChange(id,s) {
        this.props.setComponentState(this.el().id,{'align':s});
    }

    handleInputChange(e) {
        this.props.setComponentState(this.el().id,{
            [e.target.getAttribute('data-id')]:e.target.value
        });
    }

    handleBackClick() {
        this.props.setSidebarState({'visible':false});
    }

    el() {
        return this.props.builder.components[this.props.id];
    }

    renderFields() {
        let list = [];

        for(let i=1;i<=5;i++) {
            let item = {};
            item.text = this.el()['line'+i+'_text'];
            item.link = this.el()['line'+i+'_link'];
            list.push(
                <tr key={i}>
                    <td>Line {i}</td>
                    <td><input className="form-control" data-id={'line'+i+'_text'} onChange={this.handleInputChange} value={this.el()['line'+i+'_text']} placeholder="Text" /></td>
                    <td><input className="form-control" data-id={'line'+i+'_link'} onChange={this.handleInputChange} value={this.el()['line'+i+'_link']} placeholder="https://" /></td>
                </tr>
            );
        }

        return list;
    }

    renderList() {
        let list = [];

        for(let i=1;i<=5;i++) {
            if(this.el()['line'+i+'_text'] != '') {
                list.push(
                    <li key={i}>
                        {this.el()['line'+i+'_text']}
                    </li>
                );
            }

        }

        return list;
    }


    render() {


        if(this.props.sidebar == true) {
            return(
                <div className="sidebar text" style={this.props.style}>
                    <SidebarElementHeader handleBackClick={this.handleBackClick} text="List" />

                    <div className="panel-group panel-group-continuous" id="Socialfollow-settings" aria-multiselectable="true" role="tablist">

                        <SidebarSettingAccordion selectedSetting={false} optionKey="icontypes" parent="Socialfollow-settings" title="List items">

                            <SidebarElementSetting text="Items">
                                <table style={{width:'100%'}}>
                                    <tbody>
                                        {this.renderFields()}
                                    </tbody>
                                </table>
                            </SidebarElementSetting>
                        </SidebarSettingAccordion>

                        <SidebarSettingAccordion selectedSetting={false} optionKey="font" parent="Socialfollow-settings" title="Font">
                            <SidebarElementSetting text="Font style">

                                <FontPicker
                                    fontId='font'
                                    sizeId='size'
                                    colorId='color'
                                    font={this.el().font}
                                    size={this.el().size}
                                    color={this.el().color}
                                    handleChange={this.handleChange}
                                />
                            </SidebarElementSetting>
                            <SidebarElementSetting text="Horizontal position">
                                <AlignPicker id="align" align={this.el().align} handleChange={this.handleAlignChange}/>
                            </SidebarElementSetting>

                        </SidebarSettingAccordion>


                    </div>

                </div>
            );
        }else{
            return (
                <table className="table-block" style={{width:'100%'}}>
                    <tbody>
                    <tr>
                        <td style={{textAlign:this.el().align}}>
                            <ul className="link-list" style={{fontSize:this.el().size,color:this.el().color,fontFamily:this.el().font}}>
                                {this.renderList()}
                            </ul>
                        </td>
                    </tr>
                    </tbody>
                </table>
            );
        }

    }
}
const mapStateToProps = (state) => {
    return {
        builder:state.builder
    }
}

const mapDispatchToProps = (dispatch) => {
    return bindActionCreators({setComponentState,setSidebarState},dispatch)
}

List = connect(mapStateToProps,mapDispatchToProps)(List);

export default List;





// WEBPACK FOOTER //
// ./components/builder/List.js